import React from 'react'
import { injectIntl, intlShape } from 'react-intl'

const SocialSidebar = (props) => (
  <div className="social-sidebar">
    <a href={"https://www.facebook.com/sharer.php?u="+props.url} className="facebook">Facebook</a>
    <a href={"https://twitter.com/home?status="+props.url} className="twitter">Twitter</a>
    <a href={"https://www.linkedin.com/shareArticle?url="+props.url} className="linkedin">LinkedIn</a>
    <a href={"mailto:example@example.com?body="+props.url} className="email">Email</a>
    <a href={props.url} className="url">Link</a>
  </div>
)

SocialSidebar.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(SocialSidebar)


// WEBPACK FOOTER //
// ./src/components/SocialSidebar.js